import { Component } from '@angular/core';

@Component({
  selector: 'app-companies-data-empty',
  templateUrl: './companies-data-empty.component.html',
  styleUrls: ['./companies-data-empty.component.scss']
})
export class CompaniesDataEmptyComponent {

}
